export const clearChildrenBySelector = (
  element: Element,
  selector: string,
): void => {
  const elements = element.querySelectorAll(selector)
  elements.forEach((el) => el.remove())
}
